export default [
  {
    path: "/app/rank",
    name: "Rank",
    meta: {
      title: "Rank",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/rank.vue")
  },
  {
    path: "/app/rankList",
    name: "RankList",
    meta: {
      title: "rankList",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/rankList.vue")
  },
  {
    path: "/app/newsList",
    name: "appnewsList",
    meta: {
      title: "newsList",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/NewsList.vue")
  },
  {
    path: "/app/newsDetail/:id",
    name: "appnewsDetail",
    meta: {
      title: "newsDetail",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/NewsDetail.vue")
  },
  {
    path: "/app/readMe",
    name: "appreadme",
    meta: {
      title: "newsreadme",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/readme.vue")
  },
  {
    path: "/app/whatsApp",
    name: "appwhatsApp",
    meta: {
      title: "appmsgList",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/whatsApp.vue")
  },
  {
    path: "/app/userMessages",
    name: "appuserMessages",
    meta: {
      title: "appuserMessagaes",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/userMessages.vue")
  },
  {
    path: "/app/userPromotionInfo",
    name: "appuserPromotionInfo",
    meta: {
      title: "appuserPromotionInfo",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/user_promotion_info.vue")
  },
  
  
];
//抢购
